export default "__VITE_PUBLIC_ASSET__c979f7c0__"